var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { baseApiUrl } from "../environment";
import Cookies from "js-cookie";
import { parseHeader } from "../utilities/axios-utility";
var HttpClientService = /** @class */ (function () {
    function HttpClientService(baseUrl) {
        if (baseUrl === void 0) { baseUrl = ""; }
        // You may want to configure interceptors here for Authorization: "Bearer ..."
        Object.defineProperty(this, "axiosInstance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axiosInstance = axios.create({ baseURL: baseUrl || baseApiUrl, withCredentials: true });
        this.initialize();
    }
    Object.defineProperty(HttpClientService.prototype, "initialize", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.axiosInstance.interceptors.request.use(function (config) {
                // TODO add this later when we will have authorization without using cookies
                // if (this.token)
                // 	config.headers['Authorization'] = `Bearer ${this.token}`;
                config.headers["Content-Type"] = config.headers["Content-Type"] || "application/json";
                config.headers["Access-Control-Allow-Origin"] = "*";
                //.ASPXAUTH.TOKEN
                var token = Cookies.get(".ASPXAUTH.TOKEN");
                if (token)
                    config.headers["Authorization"] = token;
                return config;
            }, function (error) {
                return Promise.reject(error);
            });
            this.axiosInstance.interceptors.response.use(function (response) {
                return response;
            }, function (error) {
                if (error.response.status === 401) {
                    window.location.href = "/logout";
                }
                return Promise.reject(error);
            });
        }
    });
    Object.defineProperty(HttpClientService.prototype, "changeBaseUrl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (url) {
            this.axiosInstance.defaults.baseURL = url;
        }
    });
    Object.defineProperty(HttpClientService.prototype, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (path, request) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.axiosInstance.get(path, { params: request }).then(function (r) { return r.data; })];
                });
            });
        }
    });
    Object.defineProperty(HttpClientService.prototype, "post", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (path, request) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.axiosInstance.post(path, request).then(function (r) { return r.data; })];
                });
            });
        }
    });
    Object.defineProperty(HttpClientService.prototype, "postEmpty", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (path) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.axiosInstance.post(path).then(function (r) { return r.data; })];
                });
            });
        }
    });
    Object.defineProperty(HttpClientService.prototype, "postFile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (path, request) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.axiosInstance
                            .post(path, request, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                            .then(function (r) { return r.data; })];
                });
            });
        }
    });
    Object.defineProperty(HttpClientService.prototype, "put", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (path, request, config) {
            if (config === void 0) { config = {}; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.axiosInstance.put(path, request, config).then(function (r) { return r.data; })];
                });
            });
        }
    });
    Object.defineProperty(HttpClientService.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (path) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.axiosInstance.delete(path).then(function (r) { return r.data; })];
                });
            });
        }
    });
    Object.defineProperty(HttpClientService.prototype, "getFile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (path) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.axiosInstance
                            .get(path, {
                            responseType: "blob",
                        })
                            .then(function (response) {
                            var contentDisposition = response.headers["content-disposition"];
                            // 2) set the fileName variable to the default value
                            var fileName = "";
                            // 3) if the header is set, extract the filename
                            if (contentDisposition) {
                                var fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                                if ((fileNameMatch === null || fileNameMatch === void 0 ? void 0 : fileNameMatch.length) === 2) {
                                    fileName = fileNameMatch[1];
                                }
                            }
                            // create file link in browser's memory
                            var href = URL.createObjectURL(response.data);
                            // create "a" HTML element with href to file & click
                            var link = document.createElement("a");
                            link.href = href;
                            link.setAttribute("download", fileName); //or any other extension
                            document.body.appendChild(link);
                            link.click();
                            // clean up "a" element & remove ObjectURL
                            document.body.removeChild(link);
                            URL.revokeObjectURL(href);
                        })];
                });
            });
        }
    });
    Object.defineProperty(HttpClientService.prototype, "downloadFileByPost", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (path, request) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.axiosInstance
                            .post(path, request, {
                            responseType: "blob",
                        })
                            .then(function (response) {
                            var _a;
                            var fileName = (_a = parseHeader(response.headers["content-disposition"])["filename"]) !== null && _a !== void 0 ? _a : "";
                            var href = URL.createObjectURL(response.data);
                            // create "a" HTML element with href to file & click
                            var link = document.createElement("a");
                            link.href = href;
                            link.setAttribute("download", fileName); //or any other extension
                            document.body.appendChild(link);
                            link.click();
                            // clean up "a" element & remove ObjectURL
                            document.body.removeChild(link);
                            URL.revokeObjectURL(href);
                        })];
                });
            });
        }
    });
    return HttpClientService;
}());
export default HttpClientService;
